import { PRINTER_BRANDS } from '~/main/printer/types';
import { SUPPORTED_PRINTERS } from '~/main/printer/utils/supported-printers';

export const URL = {
  ABOUT_HUB: 'https://retail-support.lightspeedhq.com/hc/articles/360045093454',
  SUPPORTED_DEVICES: 'https://retail-support.lightspeedhq.com/hc/articles/360045636354',
  LABEL_PRINTER: {
    ABOUT: 'https://retail-support.lightspeedhq.com/hc/articles/1260806308990',
    TROUBLESHOOTING: 'https://retail-support.lightspeedhq.com/hc/articles/115000402107',
    CHANGE_PAPER_ROLL: 'https://retail-support.lightspeedhq.com/hc/articles/1260807057150',
  },
  RECEIPT_PRINTER: {
    CHANGE_PAPER_ROLL: 'https://retail-support.lightspeedhq.com/hc/articles/360045789934',
    ADD_PRINTER_BY_IP: 'https://retail-support.lightspeedhq.com/hc/articles/1260802036030',
  },
  CFD: 'https://retail-support.lightspeedhq.com/hc/articles/360042245893',
  CONNECT_CASH_DRAWER: 'https://retail-support.lightspeedhq.com/hc/articles/228842547',
  NETWORK: {
    EPSON: {
      [SUPPORTED_PRINTERS.EPSON.TM_M30]:
        'https://retail-support.lightspeedhq.com/hc/articles/360045854854',
      [SUPPORTED_PRINTERS.EPSON.TM_T88V]:
        'https://retail-support.lightspeedhq.com/hc/articles/360045854754',
    },
  },
  USB: {
    EPSON: {
      [SUPPORTED_PRINTERS.EPSON.TM_M30]:
        'https://retail-support.lightspeedhq.com/hc/articles/360045848374',
      [SUPPORTED_PRINTERS.EPSON.TM_T88V]:
        'https://retail-support.lightspeedhq.com/hc/articles/360045848674',
    },
    ZEBRA: {
      [SUPPORTED_PRINTERS.ZEBRA.ZD410]:
        'https://retail-support.lightspeedhq.com/hc/articles/1260806308990',
    },
  },
  IDENTIFY_PRINTER: {
    [PRINTER_BRANDS.EPSON]: {
      [SUPPORTED_PRINTERS.EPSON.TM_M30]:
        'https://retail-support.lightspeedhq.com/hc/articles/360047247533',
      [SUPPORTED_PRINTERS.EPSON.TM_T88V]:
        'https://retail-support.lightspeedhq.com/hc/articles/360047247533',
    },
  },
  HUB_DOCS: {
    HUB_DRIVER_ISSUES: 'https://hub-docs.lightspeed.app/docs/troubleshoot/hub-driver-issues',
    NO_DRIVER_INSTALLED: 'https://hub-docs.lightspeed.app/docs/troubleshoot/no-driver-installed',
    LABEL_PRINTER_WONT_CALIBRATE:
      'https://hub-docs.lightspeed.app/docs/troubleshoot/label-printer-wont-calibrate',
    CASH_DRAWER_NOT_OPENING:
      'https://hub-docs.lightspeed.app/docs/troubleshoot/cash-drawer-not-opening',
  },
  HUB_CHANGELOG: 'https://github.com/lightspeed/hub/releases',
} as const;
